export default [
  {
    path: '/commission/login',
    name: 'LoginCommission',
    component: () => import('@/pages/commission/LoginCommission.vue'),
    meta: { title: '业绩分佣', topNavName: '业绩分佣' },
  },
  {
    path: '/commission/detail',
    name: 'DetailCommission',
    component: () => import('@/pages/commission/DetailCommission.vue'),
    meta: {
      title: '业绩分佣',
      topNavName: '业绩分佣',
      storePath: '/store/commission/detail',
    },
  },
  {
    path: '/commission/yeeDetail',
    name: 'YeeDetailCommission',
    component: () =>
      import('@/pages/commission/YeeDetailCommission/YeeDetailCommission.vue'),
    meta: {
      title: '业绩分佣',
      topNavName: '业绩分佣',
      storePath: '/store/commission/yeeDetail',
    },
  },
  {
    path: '/commission/incomepage',
    name: 'IncomePage',
    component: () => import('@/pages/commission/IncomePage.vue'),
    meta: {
      title: '收益明细-自动结算',
      topNavName: '收益明细-自动结算',
      storePath: '/store/commission/incomepage',
    },
  },
  {
    path: '/commission/incomepagemanual',
    name: 'IncomePageManual',
    component: () => import('@/pages/commission/IncomePageManual.vue'),
    meta: {
      title: '收益明细-对账结算',
      topNavName: '收益明细-对账结算',
      storePath: '/store/commission/incomepagemanual',
    },
  },
  {
    path: '/commission/yeeIncomepage', // 易宝
    name: 'IncomePage',
    component: () => import('@/pages/commission/YeeIncomePage.vue'),
    meta: {
      title: '收益明细-自动结算',
      topNavName: '收益明细-自动结算',
      storePath: '/store/commission/yeeIncomepage',
    },
  },
  {
    path: '/commission/yeeIncomepagemanual', // 易宝
    name: 'IncomePageManual',
    component: () => import('@/pages/commission/YeeIncomePageManual.vue'),
    meta: {
      title: '收益明细-对账结算',
      topNavName: '收益明细-对账结算',
      storePath: '/store/commission/yeeIncomepagemanual',
    },
  },
  {
    path: '/commission/withdrawalrecord',
    name: 'withdrawalrecord',
    component: () => import('@/pages/commission/WithdrawalRecorde.vue'),
    meta: {
      title: '提现明细',
      topNavName: '提现明细',
      storePath: '/store/commission/withdrawalrecord',
    },
  },
  {
    path: '/commission/yeeWithdrawalrecord',
    name: 'yeeWithdrawalrecord',
    component: () => import('@/pages/commission/YeeWithdrawalRecorde.vue'),
    meta: {
      title: '提现明细', // 易宝
      topNavName: '提现明细',
      storePath: '/store/commission/yeeWithdrawalrecord',
    },
  },
  {
    path: '/commission/cardbind',
    name: 'cardbind',
    component: () => import('@/pages/commission/CardBind.vue'),
    meta: {
      title: '银行卡换绑',
      topNavName: '银行卡换绑',
      storePath: '/store/commission/cardbind',
    },
  },
  {
    path: '/commission/YeeCardbind',
    name: 'Yeecardbind',
    component: () => import('@/pages/commission/YeeCardBind.vue'),
    meta: {
      title: '银行卡换绑',
      topNavName: '银行卡换绑',
      storePath: '/store/commission/YeeCardbind',
    },
  },
  {
    path: '/commission/cardbinding',
    name: 'cardbinding',
    component: () => import('@/pages/commission/CardBinding.vue'),
    meta: { title: '银行卡绑定', topNavName: '银行卡绑定' },
  },
  {
    path: '/commission/yeeCardbinding',
    name: 'yeeCardbinding',
    component: () => import('@/pages/commission/YeeCardBinding.vue'),
    meta: { title: '银行卡绑定', topNavName: '银行卡绑定' }, // 易宝
  },
  {
    path: '/commission/transferdetail',
    name: 'TransferDetail',
    component: () => import('@/pages/commission/TransferDetail.vue'),
    meta: { title: '转账明细', topNavName: '转账明细' },
  },
  {
    path: '/commission/yeeTransferdetail',
    name: 'YeeTransferDetail',
    component: () => import('@/pages/commission/YeeTransferDetail.vue'),
    meta: { title: '转账明细', topNavName: '转账明细' },
  },
  {
    path: '/commission/balanceDetail',
    name: 'BalanceDetail',
    component: () => import('@/pages/commission/BalanceDetail.vue'),
    meta: {
      title: '账户余额明细',
      topNavName: '账户余额明细',
      storePath: '/store/commission/balanceDetail',
    },
  },
  /** 易宝账户余额明细 */
  {
    path: '/commission/yeeBalanceDetail',
    name: 'BalanceDetail',
    component: () =>
      import('@/pages/commission/YeeBalanceDetail/YeeBalanceDetail.vue'),
    meta: {
      title: '账户余额明细',
      topNavName: '账户余额明细',
      storePath: '/store/commission/yeeBalanceDetail',
    },
  },
  {
    path: '/commission/cardbindinguser',
    name: 'cardbindinguser',
    component: () => import('@/pages/commission/CardBindingUser.vue'),
    meta: {
      title: '用户银行卡绑定',
      topNavName: '用户银行卡绑定',
      storePath: '/store/commission/cardbindinguser',
    },
  },
  {
    path: '/commission/yeeCardbindinguser',
    name: 'yeeCardbindinguser',
    component: () => import('@/pages/commission/YeeCardBindingUser.vue'),
    meta: {
      title: '用户银行卡绑定',
      topNavName: '用户银行卡绑定',
      storePath: '/store/commission/yeeCardbindinguser',
    },
  },
  {
    path: '/commission/applyCommissionAccount',
    name: 'applyCommissionAccount',
    component: () => import('@/pages/commission/ApplyCommissionAccount.vue'),
    meta: { title: '开户申请', topNavName: '开户申请' },
  },
  {
    path: '/commission/waitSettleView',
    name: 'waitSettleView',
    component: () => import('@/pages/commission/waitSettleView.vue'),
    meta: { title: '业绩分佣' },
  },
  {
    path: '/commission/updateInfo',
    name: 'updateInfo',
    component: () => import('@/pages/commission/updateInfo.vue'),
    meta: { title: '资料更新' },
  },
]
